import { Row } from '@design-system/components/grid/grid';
import { Content, PurchaseInfo } from '../model/extras.domain';
import { Typography } from '@design-system/components/typography/typography';
import SuperTooltip from '@client/new/components/SuperTooltip/SuperTooltip';
import {
  typeSuperTooltipId,
  typeToModalTitle,
} from '../viewModel/extras.mappers';
import { AccessMethodsList } from './AccessMethodsList';
import { AccessMethodItem } from '../viewModel/extras.viewModel.types';
import { color } from '@design-system/tokens';

const renderPurchaseInfoBadges = (purchaseInfo: PurchaseInfo) => {
  if (purchaseInfo.type === 'not-purchasable') {
    return null;
  }

  const items: AccessMethodItem[] = [];

  if (purchaseInfo.accessMethod === 'SubscriptionAndBundles') {
    items.push({
      type: 'label',
      text: 'Subscription',
    });
  }

  if (
    purchaseInfo.accessMethod === 'BundlesOnly' ||
    purchaseInfo.accessMethod === 'SubscriptionAndBundles'
  ) {
    purchaseInfo.bundles.forEach((bundle) => {
      items.push({
        type: 'bundle',
        id: bundle.id,
        title: bundle.title,
        status: bundle.status,
      });
    });
  }

  if (purchaseInfo.accessMethod === 'Default') {
    items.push({
      type: 'label',
      text: 'Any Purchase',
    });
  }

  const colorToStatus = {
    published: color['G-40'],
    archived: color['D-60'],
    draft: color['D-60'],
  };

  return (
    <AccessMethodsList
      itemsGap="s"
      items={items}
      maxVisible={4}
      direction="row"
      renderItem={(item: AccessMethodItem, index: number) => {
        if (item.type === 'label') {
          return (
            <Typography key={`label-${index}`} variant="body" size="small">
              {item.text}
            </Typography>
          );
        }

        return (
          <div
            key={item.id}
            style={{
              background: `rgb(${colorToStatus[item.status]})`,
              borderRadius: 4,
              padding: '4px',
              display: 'inline-block',
            }}
          >
            <Typography
              variant="body"
              size="small"
              style={{ fontSize: '10px' }}
            >
              {item.title}
            </Typography>
          </div>
        );
      }}
    />
  );
};

export const ExtrasFormHeader = (p: { content: Content }) => {
  const templateId =
    p.content.type in typeSuperTooltipId
      ? typeSuperTooltipId[p.content.type as keyof typeof typeSuperTooltipId]
      : undefined;

  return (
    <>
      <Row>
        <Typography variant="title" size="large" fontWeight="medium">
          {typeToModalTitle(p.content.type)}
        </Typography>
        {templateId && <SuperTooltip templateId={templateId} />}
      </Row>
      {p.content.value?.purchaseInfo && (
        <>{renderPurchaseInfoBadges(p.content.value.purchaseInfo)}</>
      )}
    </>
  );
};
